import React from "react";
import * as PropTypes from "prop-types";
import { Link } from "gatsby-plugin-intl";
import {
  Tag,
  TagIcon,
  TagLabel,
} from "@chakra-ui/core";

const URI = '/home-service';

const DeliveryTag = ({
 listing, intl,
}) => {
  const otherProps = listing ? {
    fontSize: "0.6rem",
    mb: .5,
  } : {
    my: 1,
    fontSize: "0.8rem",
  };
  return (
    <Link to={URI}>
      <Tag
        minHeight="1rem"
        mr={1}
        rounded="full"
        variantColor="red"
        verticalAlign="bottom"
        {...otherProps}
      >
        <TagIcon icon="maclicDelivery" size="12px" />
        <TagLabel>
          {intl.formatMessage({ id: 'homeservice.button' })}
        </TagLabel>
      </Tag>
    </Link>
  );
}

DeliveryTag.propTypes = {
  listing: PropTypes.bool,
  intl: PropTypes.func.isRequired,
};

DeliveryTag.defaultProps = {
  listing: false,
};

export default DeliveryTag;
